export default __webpack_public_path__ + "static/linkedin-703626263087e3e7c315bb9ac862f8d5.png";